export default __webpack_public_path__ + "static/KIDSANDUS_RGB-da2e2a01e3e74085ca85e6ece7a00da7.png";